import { Controller } from "@hotwired/stimulus";

// Keeps the product panel's per-location price table in step with the Sold-at-locations multiselect,
// so a location the admin just added (or removed) shows in the table right away — before the edit is
// saved. The table is server-rendered (resolved prices and tax come from Nexus), so rather than build
// rows client-side we reload its turbo frame with the multiselect's current selection.
//
// Lives on the wrapper around the multiselect and the pos-product-prices frame; the multiselect's
// bubbling `change` event triggers #refresh.
export default class extends Controller {
  static values = { url: String };

  refresh(event) {
    // React only to the locations multiselect, not to any other change that bubbles here.
    const fromLocations =
      event.target?.name === "record[locations][]" ||
      event.target?.closest?.("[data-multiselect-target='hiddenContainer']");
    if (!fromLocations) return;

    // Debounce: toggling several locations quickly should reload the table once.
    clearTimeout(this.refreshTimeout);
    this.refreshTimeout = setTimeout(() => this.reload(), 150);
  }

  reload() {
    const frame = this.element.querySelector("#pos-product-prices");
    if (!frame) return;

    const url = new URL(this.urlValue, window.location.origin);
    this.selectedLocationIds().forEach((id) => url.searchParams.append("location_ids[]", id));
    frame.src = url.pathname + url.search;
  }

  selectedLocationIds() {
    return Array.from(this.element.querySelectorAll("input[name='record[locations][]']"))
      .map((input) => input.value)
      .filter(Boolean);
  }

  disconnect() {
    clearTimeout(this.refreshTimeout);
  }
}
